module.exports = __webpack_public_path__ + "img/motorcycle_parking.44db2430.svg";